import React from 'react';
import { Text, Pressable, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import OPComponent from '../components/op_component';

export default class NavbarButton extends OPComponent {
  render() {
    return (
      <Pressable style={styles.button} onPress={this.props.onPress} disabled={!this.props.enabled}>
        <Text style={[styles.buttonText, !this.props.enabled ? styles.disabled : {}]}>
          {this.props.label}
        </Text>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  button: THEME.customNavBarTextStyle,
  disabled: THEME.disabled,
  buttonText: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.regular,
    color: COLOR.emphasis,
  },
});
